module.exports = __webpack_public_path__ + "static/img/report-bg.6ddf559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report-bg.png
// module id = sPJe
// module chunks = 1